import { MuiIcons } from '@osu/react-ui';
import { AUTH_ROLES } from "../../../util/constants";
import DialogAssignToProgram from "./DialogAssignToProgram";
import DialogResumeLater from "./DialogResumeLater";
import DialogAdminRecommendation from "./DialogAdminRecommendation";
import {
    DialogProgramChangeApprove,
    DialogProgramChangeDeny,
    DialogWithdrawApprove,
    DialogWithdrawCancel,
} from "./DialogScholarsStudentRequestBase";

// Scholars applicant-details Actions menu items. Mirrors the Honors menuItemsEnum shape (label/type/roles/
// icon/component) so the shared ButtonAndPopupMenu + MenuDialogBase render them identically. Kept separate
// from the Honors enum because the Scholars page uses its own details cache and role-gating (FR-22: Honors
// resolvers/logic are never modified, and vice-versa).
export const scholarsMenuItemsEnum = [
    {
        label: "Assign to Scholars Program",
        type: "ASSIGN_PROGRAM",
        roles: [AUTH_ROLES.SCHOLARS_ADMIN],
        icon: <MuiIcons.AssignmentInd />,
        component: DialogAssignToProgram,
        // Hidden: manual assign is not offered in the UI. The handler never transitioned the Application
        // to SCHOLARS_IN_REVIEW, so manually-assigned applicants were stranded off "Recommendations to
        // Approve". Disabled via the enum's feature-flag mechanism (useScholarsActionMenuItems skips
        // items with disabled === true) rather than deleted, so it can be re-enabled if the gap is fixed.
        disabled: true,
    },
    {
        label: "Resume Later",
        type: "RESUME_LATER",
        roles: [AUTH_ROLES.SCHOLARS_ADMIN, AUTH_ROLES.SCHOLARS_PROGRAM_MANAGER, AUTH_ROLES.SCHOLARS_REVIEWER],
        icon: <MuiIcons.Schedule />,
        // Only show when the caller owns this applicant's active placement (they pulled it from the queue or
        // it was manually assigned to them) — you can't resume an applicant you aren't working.
        specialCaseFilterFns: [ (extraInfo) => extraInfo.isOwnInProgress ],
        component: DialogResumeLater,
    },
    {
        // Single-applicant administrative recommendation. ADMIN-only — the same admin recommendation as the
        // Advanced Search bulk action, scoped to THIS applicant and run synchronously (adminRecommendScholar).
        // Previously the only way to post an admin recommendation on the Scholars side was the bulk action
        // from Advanced Search; this gives admins a per-applicant path from the applicant detail page.
        label: "Administrative Recommendation",
        type: "ADMIN_RECOMMENDATION",
        roles: [AUTH_ROLES.SCHOLARS_ADMIN],
        icon: <MuiIcons.Gavel />,
        component: DialogAdminRecommendation,
    },
    {
        label: "Approve Student Withdraw Request",
        type: "APPROVE_WITHDRAW_REQUEST",
        roles: [AUTH_ROLES.SCHOLARS_ADMIN],
        icon: <MuiIcons.CheckCircle />, 
        specialCaseFilterFns: [ withdrawRequested, studentRequestIsActive ],
        message: "This will approve the withdraw request for the application.",
        component: DialogWithdrawApprove,
    },
    {
        label: "Cancel Student Withdraw Request",
        type: "CANCEL_WITHDRAW_REQUEST",
        roles: [AUTH_ROLES.SCHOLARS_ADMIN],
        icon: <MuiIcons.Cancel />, 
        specialCaseFilterFns: [ withdrawRequested, studentRequestIsActive ],
        message: "This will cancel the withdraw request for the application.",
        component: DialogWithdrawCancel,
    },
    {
        label: "Approve Student Program Change Request",
        type: "APPROVE_PROGRAM_CHANGE_REQUEST",
        roles: [AUTH_ROLES.SCHOLARS_ADMIN],
        icon: <MuiIcons.CheckCircle />, 
        specialCaseFilterFns: [ programChangeRequested, studentRequestIsActive ],
        message: "This will approve the program change request for the application.",
        component: DialogProgramChangeApprove,
    },
    {
        label: "Deny Student Program Change Request",
        type: "REMOVE_PROGRAM_CHANGE_REQUEST",
        roles: [AUTH_ROLES.SCHOLARS_ADMIN],
        icon: <MuiIcons.Cancel />, 
        specialCaseFilterFns: [ programChangeRequested, studentRequestIsActive ],
        message: "This will deny the program change request for the application.",
        component: DialogProgramChangeDeny,
    },
];

function studentRequestIsActive(extraInfo) { return extraInfo.studentRequestIsActive === "Yes"; }

function withdrawRequested(extraInfo) { return extraInfo.withdrawRequested }

function programChangeRequested(extraInfo) { return extraInfo.programChangeRequested }
